import { GatsbyLink } from "@mgdx-libs/link";
import { cx } from "cva";
import React from "react";

import { ButtonGatsbyLinkProps, variants } from ".";

export const ButtonLink = ({
  className,
  disabled,
  children,
  variant,
  color,
  to,
  ...props
}: Readonly<ButtonGatsbyLinkProps>) => (
  <GatsbyLink
    to={to}
    aria-disabled={disabled}
    className={cx(className, variants({ variant, color }))}
    tabIndex={disabled ? -1 : undefined}
    {...props}
  >
    {children}
  </GatsbyLink>
);
